import React, {Component} from 'react';
import BannerLink from "./Banner-link";


export default class BannerV extends Component {
    render() {
        return (
            <div className="embed-responsive embed-responsive-16by9">
                <video className="video-fluid d-block w-100" autoPlay loop>
                    <source src="./../../assets/images/banner/banner.mp4" type="video/mp4"/>
                </video>
                <BannerLink />
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/banner/BannerV.js